import { Route, Routes } from "react-router-dom";
import { Error404 } from 'pages';
import DataModifySetting from "pages/management/setting/data/data-modify";
import DataAddSetting from "pages/management/setting/data/data-add";
import DataSetting from "pages/management/setting/data/data";

export default function MonitoringSettingDataRoutes(props) {

    return (
        <Routes>
            <Route path="/*">
                <Route path="/*" element={ <DataSetting /> }/>
                
                <Route path="add" element={ <DataAddSetting /> }/>
                <Route path=":id" element={ <DataModifySetting /> }/>
                
                <Route path="*" element={ <Error404/> }/>
            </Route>
        </Routes>
    );
}